import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Button,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./accordion.styles.css";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";

interface AccordionBoxParams {
  readonly heading?: React.ReactNode | string;
  readonly details: React.ReactNode | string;
  readonly handleAccordionChange?: () => void;
  readonly styles?: React.CSSProperties;
  readonly isExpanded?: boolean;
  readonly isCollapseBtn?: boolean;
  readonly isBackDrop?: boolean;
}

export const AccordionBox: React.FC<AccordionBoxParams> = ({
  heading,
  details,
  isExpanded,
  isBackDrop,
  isCollapseBtn,
  handleAccordionChange,
  styles,
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const handleAccordionClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      {expanded && isBackDrop && (
        <Backdrop
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: expanded ? "block" : "none", // Show the backdrop when the Accordion is expanded
          }}
          open={expanded}
          onClick={handleAccordionChange}
        />
      )}
      {expanded && (
        <Accordion
          sx={{
            width: "100%",
            position: "relative",
            overflowY: "auto",
            ...styles,
          }}
          expanded={expanded}
          onChange={handleAccordionClick}
        >
          <AccordionSummary
            sx={{
              cursor: "auto",
              "& .MuiAccordionSummary-content": {
                margin: "0px",
                cursor: "auto",
              },
            }}
          >
            {heading}
          </AccordionSummary>
          <AccordionDetails sx={{ marginTop: "-60px", overflowY: "auto" }}>
            {details}
          </AccordionDetails>
        </Accordion>
      )}
      {isCollapseBtn && (
        <IconButton
          sx={{
            position: "relative",
            top: expanded ? "-40px" : "-23px",
            left: "48.5%",
            background: "wheat",
          }}
          className={expanded ? "icon-expanded" : "icon-collapsed"}
          onClick={handleAccordionClick}
        >
          {expanded ? (
            <ExpandLessIcon fontSize="large" color="action" />
          ) : (
            <ExpandMoreIcon fontSize="large" color="action" />
          )}
        </IconButton>
      )}
    </>
  );
};
